import React, { useState } from 'react';

const services = [
  {
    title: 'מערכות ניהול לעסקים',
    text: 'בניית מערכות פנימיות לניהול הזמנות, עובדים, לקוחות, מלאי, תורים, מסכים חכמים ותהליכי עבודה.',
    image: 'management',
  },
  {
    title: 'אפליקציות Web ומובייל',
    text: 'פיתוח ממשקים מהירים, נקיים ורספונסיביים למחשב, טאבלט, טלפון ומסכי Android TV.',
    image: 'apps',
  },
  {
    title: 'אוטומציה ו־AI',
    text: 'חיבור תהליכים חכמים, דוחות, בוטים, ניתוח נתונים וכלים שחוסכים זמן וכסף לעסק.',
    image: 'ai',
  },
  {
    title: 'אתרים ודפי נחיתה',
    text: 'עיצוב ובנייה של אתרים מודרניים שמציגים את העסק בצורה חזקה, אמינה ומוכרת.',
    image: 'landing',
  },
];

const projects = [
  { name: 'Servix', desc: 'מערכת הזמנות, טאבלט, מטבח ומסכי תצוגה לעסקים.' },
  { name: 'Zono', desc: 'פלטפורמה דיגיטלית לניהול שירותים, לקוחות ותהליכים.' },
  { name: 'BuzzBeam', desc: 'מערכת פרסום חכמה למסכי TV וערוצים עסקיים.' },
];

const testimonials = [
  {
    name: 'בעל עסק בתחום השירותים',
    text: 'המערכת הפכה את העבודה למסודרת יותר. פחות בלגן, פחות טעויות, והרבה יותר שליטה ביום יום.',
  },
  {
    name: 'מנהל סניף',
    text: 'קיבלנו פתרון פשוט לעובדים וחכם להנהלה. הממשק ברור גם למי שלא טכנולוגי.',
  },
  {
    name: 'לקוח פרטי',
    text: 'העיצוב נראה מקצועי מאוד, והמערכת נטענת מהר גם בטלפון וגם בטאבלט.',
  },
];

function ServiceIllustration({ type }) {
  return (
    <div className={`illustration ${type}`} aria-hidden="true">
      <div className="screen">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div className="orb one"></div>
      <div className="orb two"></div>
      <div className="mini-card"></div>
    </div>
  );
}

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="site-shell" dir="rtl">
      <header className="navbar">
        <a className="brand" href="#home" onClick={closeMenu}>
          <span className="brand-mark">MB</span>
          <span>
            <strong>MBVIP SOFT</strong>
            <small>תוכנה שמזיזה עסקים קדימה</small>
          </span>
        </a>

        <button className="menu-button" onClick={() => setMenuOpen(!menuOpen)} aria-label="פתיחת תפריט">
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={menuOpen ? 'nav-links open' : 'nav-links'}>
          <a href="#services" onClick={closeMenu}>שירותים</a>
          <a href="#about" onClick={closeMenu}>מי אנחנו</a>
          <a href="#projects" onClick={closeMenu}>פרויקטים</a>
          <a href="#clients" onClick={closeMenu}>לקוחות</a>
          <a className="nav-cta" href="#contact" onClick={closeMenu}>דברו איתנו</a>
        </nav>
      </header>

      <main>
        <section id="home" className="hero section-pad">
          <div className="hero-content">
            <p className="eyebrow">פיתוח תוכנה · מערכות חכמות · דיגיטל לעסקים</p>
            <h1>בונים לעסק שלך נוכחות דיגיטלית חזקה, מערכת יציבה וחוויית משתמש שמרגישים מיד.</h1>
            <p className="hero-text">
              MBVIP SOFT מפתחת פתרונות תוכנה לעסקים שרוצים לעבוד מסודר, מהר וחכם יותר — מאתר תדמית ועד מערכת מלאה עם דשבורדים, טאבלטים, מסכים, API ואוטומציות.
            </p>
            <div className="hero-actions">
              <a className="primary-btn" href="#services">לראות שירותים</a>
              <a className="secondary-btn" href="https://servix.mbvipsoft.com">כניסה ל־Servix</a>
            </div>
            <div className="stats">
              <span><strong>360°</strong> פתרון מקצה לקצה</span>
              <span><strong>RTL</strong> עברית וערבית</span>
              <span><strong>TV</strong> טאבלט ומובייל</span>
            </div>
          </div>

          <div className="hero-visual">
            <div className="dashboard-card main-card">
              <div className="card-header">
                <span></span><span></span><span></span>
              </div>
              <div className="dashboard-grid">
                <div></div><div></div><div></div><div></div>
              </div>
              <div className="chart-lines">
                <span></span><span></span><span></span>
              </div>
            </div>
            <div className="floating-panel top">API</div>
            <div className="floating-panel bottom">React</div>
          </div>
        </section>

        <section id="services" className="section-pad">
          <div className="section-title">
            <p className="eyebrow">מה אנחנו עושים</p>
            <h2>שירותים שמחברים בין עיצוב, קוד ותוצאה עסקית</h2>
            <p>כל שירות נבנה סביב צורך אמיתי: לחסוך זמן, להפחית טעויות, לשפר מכירה ולתת ללקוח תחושה של עסק רציני.</p>
          </div>

          <div className="services-grid">
            {services.map((service) => (
              <article className="service-card" key={service.title}>
                <ServiceIllustration type={service.image} />
                <h3>{service.title}</h3>
                <p>{service.text}</p>
              </article>
            ))}
          </div>
        </section>

        <section id="about" className="about section-pad">
          <div>
            <p className="eyebrow">מי אנחנו</p>
            <h2>אנחנו לא רק כותבים קוד — אנחנו בונים מערכת שעוזרת לעסק לנשום.</h2>
          </div>
          <div className="about-box">
            <p>
              MBVIP SOFT מתמקדת בפיתוח פתרונות תוכנה מודרניים לעסקים קטנים, בינוניים ויזמים. אנחנו משלבים חשיבה עסקית, עיצוב נקי, פיתוח React, Backend, API, בסיסי נתונים, אוטומציות וחיבור למסכים חכמים.
            </p>
            <p>
              המטרה שלנו היא להפוך רעיון למוצר עובד: ברור ללקוח, קל לעובדים, מדויק למנהלים ומוכן לגדול בעתיד.
            </p>
          </div>
        </section>

        <section id="projects" className="section-pad projects-section">
          <div className="section-title">
            <p className="eyebrow">המערכות שלנו</p>
            <h2>כל פרויקט מקבל מקום משלו, דומיין משלו וזהות משלו</h2>
          </div>
          <div className="projects-grid">
            {projects.map((project) => (
              <article className="project-card" key={project.name}>
                <span>{project.name}</span>
                <h3>{project.desc}</h3>
                <a href={`https://${project.name.toLowerCase()}.mbvipsoft.com`} target="_blank" 
                rel="noopener noreferrer">כניסה למערכת</a>
              </article>
            ))}
          </div>
        </section>

        <section className="vision section-pad">
          <div className="vision-card">
            <p className="eyebrow">לאן אנחנו רוצים להגיע</p>
            <h2>לבנות אקוסיסטם של מוצרים דיגיטליים שמשרתים עסקים בכל יום.</h2>
            <p>
              החזון הוא ליצור משפחה של מערכות תחת MBVIP SOFT: הזמנות, פרסום, ניהול לקוחות, מסכים חכמים, אוטומציות ו־AI — הכל בגישה פשוטה, יפה ומדויקת.
            </p>
          </div>
        </section>

        <section id="clients" className="section-pad">
          <div className="section-title">
            <p className="eyebrow">לקוחות וחוות דעת</p>
            <h2>מה לקוחות מרגישים אחרי שהמערכת נכנסת לעבודה</h2>
          </div>
          <div className="testimonials-grid">
            {testimonials.map((item) => (
              <article className="testimonial" key={item.name}>
                <p>“{item.text}”</p>
                <strong>{item.name}</strong>
              </article>
            ))}
          </div>
        </section>

        <section id="contact" className="contact section-pad">
          <div>
            <p className="eyebrow">מתחילים נכון</p>
            <h2>יש לך רעיון, עסק או מערכת שצריך לסדר?</h2>
            <p>נוכל לבנות יחד פתרון חכם, מודרני ומוכן לצמיחה.</p>
          </div>
          <a className="primary-btn" href="mailto:info@mbvipsoft.com">info@mbvipsoft.com</a>
        </section>
      </main>

      <footer>
        <strong>MBVIP SOFT</strong>
        <span>© {new Date().getFullYear()} כל הזכויות שמורות</span>
      </footer>
    </div>
  );
}

export default App;
